define('modules/form_editor/models/custom_linlogin',['require','exports','module','./base_form_element','modules/editor/models/editorstate'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element"),
      EditorState = require("modules/editor/models/editorstate");

  module.exports = BaseFormElement.extend({
    name: "custom:login:linkedin",
    isIntegrable: false,
    onlyFieldAttrs: true,
    defaultValues: {
      appId: "",
      size: "small",
      position: "center",
      idName: "lpg-lin-login"
    },
    initialize: function(){
      module.exports.__super__.initialize.apply(this, arguments);
      this.on("change:appId", this.notifyIdChange);
    },
    notifyIdChange: function(model, id) {
      EditorState.setLinkedInAppId(id);
    }
  });
});

